import { createSelector } from 'reselect'

export const selectLocation = (state, id) => state.locations.allById[id]
export const selectLocationIds = state => state.locations.allIds
export const selectIsLocationVisible = (state, id) =>
  state.locations.isVisibleById[id]
export const selectVisibleLocationIds = state =>
  selectLocationIds(state).filter(id => state.locations.isVisibleById[id])
export const selectAllLocationsSelected = createSelector(
  selectLocationIds,
  selectVisibleLocationIds,
  (allIds, selectedIds) =>
    allIds.sort().join(',') === selectedIds.sort().join(',')
)
export const selectAllLocationsHidden = createSelector(
  selectVisibleLocationIds,
  selectedIds => selectedIds.length === 0
)
